import React from "react";
import classes from "./errorView.module.css"
import MainComponent from "../MainComponent/mainComponent";

const ErrorView = props=> {

    return <MainComponent children={(
        <div className={classes.root}>The page you’re looking for can’t be found.</div>
    )} isIframe={false}/>
}

export default ErrorView;